import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
// Import TinyMCE
import tinymce from 'tinymce/tinymce';
// A theme is also required
import 'tinymce/themes/modern/theme';
// Any plugins you want to use has to be imported
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/code';
import 'tinymce/plugins/wordcount';

const CustomEditor = (props) => {
  return (
      <Editor
          value={props.value}
          init={{
              image_title: true,
              // enable automatic uploads of images represented by blob or data URIs
              automatic_uploads: true,
              // URL of our upload handler (for more details check: https://www.tinymce.com/docs/configure/file-image-upload/#images_upload_url)
              // images_upload_url: 'postAcceptor.php',
              // here we add custom filepicker only to Image dialog
              file_picker_types: 'image',
              // and here's our custom image picker
              file_picker_callback: function(cb, value, meta) {
                  var input = document.createElement('input');
                  input.setAttribute('type', 'file');
                  input.setAttribute('accept', 'image/*');

                  // Note: In modern browsers input[type="file"] is functional without
                  // even adding it to the DOM, but that might not be the case in some older
                  // or quirky browsers like IE, so you might want to add it to the DOM
                  // just in case, and visually hide it. And do not forget do remove it
                  // once you do not need it anymore.

                  input.onchange = function() {
                      var file = this.files[0];

                      var reader = new FileReader();
                      reader.onload = function () {
                          // Note: Now we need to register the blob in TinyMCEs image blob
                          // registry. In the next release this part hopefully won't be
                          // necessary, as we are looking to handle it internally.
                          var id = 'blobid' + (new Date()).getTime();
                          var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                          var base64 = reader.result.split(',')[1];
                          var blobInfo = blobCache.create(id, file, base64);
                          blobCache.add(blobInfo);

                          // call the callback and populate the Title field with the file name
                          cb(blobInfo.blobUri(), { title: file.name });
                      };
                      reader.readAsDataURL(file);
                  };

                  input.click();
              },
              image_class_list: [
                  {title: 'Responsive', value: 'img-responsive'}
              ],
              paste_postprocess: function(plugin, args) {
                  try {
                      if(args.node.children.length === 1) {
                          if( args.node.children[0].tagName === 'IMG') {
                              args.node.children[0].classList.add('img-responsive')
                          }
                      }
                  } catch (e) {}
              },
              skin_url: `${process.env.PUBLIC_URL}/skins/lightgray`,
              branding: false,
              paste_retain_style_properties: "all",
              paste_data_images: true,
              plugins: [
                  'advlist autolink lists link image charmap print preview anchor textcolor colorpicker',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table contextmenu paste code wordcount'
              ],
              toolbar: 'fontselect fontsizeselect | insert | undo redo |  formatselect | bold italic | forecolor backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
          }}
          onEditorChange={props.onEditorChange}
      />
  )
};

export default CustomEditor;